import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navigation from '../features/navigation/Navigation';
import Footer from '../features/navigation/Footer';
import './LegalPages.styles.css';

// * [PAGE] Dedicated post-conversion Thank You page meeting UX standard
export const ThankYouPage: React.FC = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
    document.title = 'Message Received | Yash Haldiya';
  }, []);

  return (
    <div className="legal-page-layout">
      <Navigation />

      <main className="legal-page-container" style={{ textAlign: 'center' }}>
        <div className="legal-document-card" style={{ maxWidth: '650px', margin: '0 auto', textAlign: 'center' }}>
          <div style={{ fontSize: '3.5rem', marginBottom: '1rem' }}>📬</div>
          <span className="legal-badge">Message Dispatched</span>
          <h1 className="legal-title" style={{ marginBottom: '1rem' }}>Thank You!</h1>
          <p className="legal-body" style={{ marginBottom: '2rem' }}>
            Your message has been securely relayed to <strong>Yash Haldiya</strong>.
            I typically respond within 24 to 48 business hours.
          </p>

          <div style={{ display: 'flex', gap: '1rem', justifyContent: 'center', flexWrap: 'wrap' }}>
            <Link to="/" className="btn btn-primary">
              <i className="fas fa-home" /> Return to Portfolio
            </Link>
            <Link to="/contact" className="btn btn-secondary">
              <i className="fas fa-paper-plane" /> Send Another
            </Link>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default ThankYouPage;
